module.exports = __webpack_public_path__ + "img/ico-pressure-low-n.7ffc99a7.png";